/*
:param pk: trade_record_id
:return:
    {
        'payment_result': 'success' / 'to be queried',  # 支付成功 / 支付还未成功
        'school_student_id': trade_record.trStudent_id,
        'school_student_name': trade_record.trStudent.ssName,
        'trade_id': pk,
        'trade_type': trade_record.trType,
        'amount_of_money': trade_record.trTransactionAmount,
        'payment_state': trade_record.payment_state,
        'class_id': trade_record.trClass_id,
    }

    如果该交易记录不是用的支付宝或微信，返回错误：
    {'result': 'failure', 'reason': 'this record was not paid by Wechat pay or Alipay'}

    如果这个学校还没通过ClassTop inc.开通微信支付或支付宝支付，返回错误，这里需要弹框提示学校联络ClassTop进行开通：
    {'result': 'failure', 'reason': 'the school has not set Wechat pay or Alipay'}
*/

import axios from "axios";
import queryString from 'query-string';
import Joi from 'joi-browser';
import { APIAddress } from "constants/config";

export default function checkSnapScan(tradeID) {

  if (typeof tradeID == 'undefined') {
    throw new Error('Missing tradeID');
  }

	return new Promise((resolve, reject) => {
    axios.put(APIAddress, {'uri': `/snap_scan/${tradeID}/`,
		'method': 'GET',
		'token': localStorage.getItem('token') })
		.then((res) => {
			resolve(res.data);
		})
		.catch((err) => {
			reject(err);
		})
	})
}



// WEBPACK FOOTER //
// ./src/controllers/controllers/payment/checkSnapScan.js